export const IRTIS3_REFRESH_INTERVAL =
  parseInt(process.env.REACT_APP_IRTIS3_REFRESH_INTERVAL as string, 10) ||
  15_000
export const IRTIS3_MAX_AMOUNT_OF_STOPS =
  parseInt(process.env.REACT_APP_IRTIS3_MAX_AMOUNT_OF_STOPS as string, 10) || 4

export const NETWORK_KEY = process.env.REACT_APP_NETWORK_KEY
export const NETWORK_BASE_URL =
  process.env.REACT_APP_NETWORK_BASEURL || 'https://api.delijn.be/network/v1'

export const TRAVELINFO_TRIP_KEY = process.env.REACT_APP_TRAVELINFO_TRIP_KEY
export const TRAVELINFO_DISTURBANCE_KEY =
  process.env.REACT_APP_TRAVELINFO_DISTURBANCE_KEY

export const TRAVELINFO_TRIP_BASEURL =
  process.env.REACT_APP_TRAVELINFO_TRIP_BASEURL ||
  'https://api.delijn.be/travelinfo-trip/v1'

export const TRAVELINFO_DISTURBANCE_BASEURL =
  process.env.REACT_APP_TRAVELINFO_DISTURBANCE_BASEURL ||
  'https://api-d.delijn.be/travelinfo-disturbance/v1'

export const APP_INSIGHTS_KEY = process.env.REACT_APP_APPLICATION_INSIGHTS_KEY

export const CONTENTFUL_SPACE_ID =
  process.env.REACT_APP_CONTENTFUL_SPACE_ID || '32fmeyn9t08i'
export const CONTENTFUL_ENVIRONMENT =
  process.env.REACT_APP_CONTENTFUL_ENVIRONMENT || 'master'
export const CONTENTFUL_ACCESS_TOKEN =
  process.env.REACT_APP_CONTENTFUL_ACCESS_TOKEN
export const CONTENTFUL_PREVIEW_ACCESS_TOKEN =
  process.env.REACT_APP_CONTENTFUL_PREVIEW_ACCESS_TOKEN
export const CONTENTFUL_IRTIS3_NOTIFICATION_ASSET_ID =
  process.env.REACT_APP_CONTENTFUL_IRTIS3_NOTIFICATION_ASSET_ID || 'xxx'
export const CONTENTFUL_IRTIS3_NOTIFICATION_REFRESH_INTERVAL =
  parseInt(
    process.env
      .REACT_APP_CONTENTFUL_IRTIS3_NOTIFICATION_REFRESH_INTERVAL as string,
    10,
  ) || 60_000 * 30 // 30 minutes default
